/* eslint-disable react-hooks/exhaustive-deps */
import { Button } from "primereact/button";
import { useEffect, useRef, useState } from "react";
import { Menu } from "primereact/menu";
import { MenuItem } from "primereact/menuitem";
import { Dropdown } from "primereact/dropdown";
import { RadioButton } from "primereact/radiobutton";
import { InputText } from "primereact/inputtext";
import {
  projectKeyTypes,
  projectKeyTypesObject,
  SORT_FILTER,
  STATUS_FILTER,
} from "../../../../util/constants";
import { InputSwitch, InputSwitchChangeEvent } from "primereact/inputswitch";
import { ProgressSpinner } from "primereact/progressspinner";
import DataTableComponent, { ColumnOption } from "../../../common/DataTable";
import { Paginator, PaginatorPageChangeEvent } from "primereact/paginator";
import { Dialog } from "primereact/dialog";
import { EditButtonSVG } from "../../../../assets/SVGs/EditButtonSVG";
import { Toast } from "primereact/toast";
import { TableSortingSVG } from "../../../../assets/SVGs/TableSortingSVG";
import { getErrorMessage } from "../../../../helper/getResponseMessage";
import { showError, showSuccess } from "../../../../util/ShowStatus";
import axios from "../../../../util/axiosconfig";
import { Calendar } from "primereact/calendar";
import { convertEpochtoDate } from "../../../../helper/DateConverters";
import { Checkbox } from "primereact/checkbox";
import FilterButton from "../common/FilterButton";
import { AutoComplete } from "primereact/autocomplete";
import { useDebounce } from "../../../../util/debounce";
import { ROLES } from "../../../../util/roleNameConstants";
import { useNavigate } from "react-router-dom";
import { Timeline } from "primereact/timeline";
import { Card } from "primereact/card";

interface Project {
  projectID?: number;
  name: string | null;
  projectKey: string | null;
  projectKeyType?: string | null;
  projectType?: any;
  addYear?: boolean;
  projectStatusChangeHistory?: any[];
  sendNewProjectCreationEmail?: boolean;
  startDate: any;
  // endDate: any;
  projectNotes?: string | null;
  managers: any;
  isActive: boolean;
}

interface FormErrors {
  name: string | null;
  projectKey: string | null;
  projectKeyType?: string | null;
  projectType?: string | null;
  startDate: string | null;
  // endDate: string | null;
  projectNotes?: string | null;
  managers: any;
  isActive: string | null;
}

interface Filters {
  name: string | null;
  projectKey: string | null;
  projectID: any;
  projectType: any;
  manager: any;
  status: "all" | "active" | "inactive";
}

const ProjectManagement = () => {
  const navigate = useNavigate();
  const [projectsLoading, setProjectsLoading] = useState<boolean>(false);
  const [generateProjectKeyLoading, setGenerateProjectKeyLoading] =
    useState<boolean>(false);
  const [isExporting, setIsExporting] = useState<boolean>(false);
  const [statusFilter, setStatusFilter] = useState<string | null>("all");
  const [isDialogVisible, setIsDialogVisible] = useState<boolean>(false);
  const [formType, setFormType] = useState<string>("add");
  const [isAddButtonDisabled, setIsAddButtonDisabled] = useState(false);
  const [selectedManager, setSelectedManager] = useState<any>(null);
  const [selectedProjectName, setSelectedProjectName] = useState<any>(null);
  const [selectedProjectKey, setSelectedProjectKey] = useState<any>(null);
  const [selectedProjectType, setSelectedProjectType] = useState<any>(null);
  const [allProjects, setAllProjects] = useState<any>([]);
  const [projectNamesuggestions, setProjectNameSuggestions] = useState<any>([]);
  const [projectKeysuggestions, setProjectKeySuggestions] = useState<any>([]);
  const [allOHDProjects, setAllOHDProjects] = useState<any>([]);
  const [showProjectDetailsToCopy, setShowProjectDetailsToCopy] =
    useState<boolean>(true);

  const [isAddYearChecked, setIsAddYearChecked] = useState<any>(false);
  const [viewHistoryPopup, setViewHistoryPopup] = useState<boolean>(false);
  const [projectStatusChangeActivity, setProjectStatusChangeActivity] =
    useState<any>([]);
  const [selectedRowData, setSelectedRowData] = useState<any>(null);

  const [formValues, setFormValues] = useState<Project>({
    name: null,
    projectKey: null,
    projectKeyType: null,
    addYear: false,
    sendNewProjectCreationEmail: false,
    projectType: null,
    startDate: null,
    projectNotes: null,
    // endDate: null,
    managers: null,
    isActive: true,
  });

  const [filters, setFilters] = useState<Filters>({
    name: null,
    projectID: null,
    projectKey: null,
    projectType: null,
    manager: null,
    status: "all",
  });
  const [formErrors, setFormErrors] = useState<FormErrors>({
    name: null,
    projectKey: null,
    projectKeyType: null,
    projectType: null,
    startDate: null,
    projectNotes: null,
    // endDate: null,
    managers: null,
    isActive: null,
  });

  const [sortFilter, setSortFilter] = useState<any>({
    sortField: "projectKeyNumber",
    sortOrder: false,
  });
  const [isStatusDialogVisible, setIsStatusDialogVisible] =
    useState<boolean>(false);
  const [statusChangeReason, setStatusChangeReason] = useState<string>("");
  const [pendingStatusChange, setPendingStatusChange] = useState<{
    projectID: number;
    isActive: boolean;
  } | null>(null);
  const [statusChangeReasonError, setStatusChangeReasonError] = useState<
    string | null
  >(null);
  const [first, setFirst] = useState<number>(0);
  const [size, setSize] = useState<number>(10);
  const [totalRecords, setTotalRecords] = useState<number>(10); // To hold the total number of records

  const [projects, setProjects] = useState<Project[]>([]); // To hold the list of projects

  const [managers, setManagers] = useState<any>([]);
  const [managersList, setManagersList] = useState<any>([]);
  const [selectedProjectKeyType, setSelectedProjectKeyType] =
    useState<any>(null);
  const [projectTypes, setProjectTypes] = useState<any>([]);
  const page = 0;

  const menu = useRef<Menu>(null);
  const toast = useRef<Toast>(null);

  const fetchProjectTypes = async () => {
    try {
      const response = await axios.get("tl-admin/project-type");
      setProjectTypes(response.data.result);
    } catch (error) {
      const errorMessage = getErrorMessage(error);
      showError(errorMessage, toast);
    }
  };

  const searchProjectNameWithDebounce = useDebounce(
    filters?.name?.trim() ?? null
  );
  const searchProjectKeyWithDebounce = useDebounce(
    filters?.projectKey?.trim() ?? null
  );

  const fetchProjects = async (page: number, size: number, type?: string) => {
    try {
      const params: any = {
        size,
        page,
        sortField: sortFilter.sortField,
        sortOrder:
          sortFilter.sortOrder === true ? SORT_FILTER.ASC : SORT_FILTER.DESC,
      };

      if (searchProjectNameWithDebounce) {
        params.projectName = searchProjectNameWithDebounce;
      }
      if (searchProjectKeyWithDebounce) {
        params.projectKey = searchProjectKeyWithDebounce;
      }

      if (filters?.projectType) {
        params.projectTypeID = filters?.projectType.projectTypeID;
      }

      if (filters?.manager) {
        params.managerID = filters?.manager.userID;
      }
      if (statusFilter !== "all") {
        params.isActive = statusFilter === "active" ? true : false;
      }
      if (type === "export") {
        try {
          setIsExporting(true);
          const response = await axios.get("tl-admin/export-project", {
            params,
            responseType: "blob", // Important for binary data
          });

          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.download = "project_report.csv";

          // Append to body and trigger download
          document.body.appendChild(link);
          link.click();

          // Clean up
          link.parentNode?.removeChild(link);
          window.URL.revokeObjectURL(url);
        } catch (error) {}
      } else {
        setProjectsLoading(true);
        const response = await axios.get("tl-admin/project/all", { params });
        const newProjects = response.data.result.filter((project: any) => {
          return project.projectKey !== "TBC"; // Filter out projects with null projectKey
        });
        setProjects(newProjects);
        setTotalRecords(response.data.totalRecords); // Assuming the API returns the total count
      }
      setIsExporting(false);
      setProjectsLoading(false);
    } catch (err) {
      const error = getErrorMessage(err);
      setIsExporting(false);
      setProjectsLoading(false);
      showError(error, toast);
    }
  };

  const generateProjectKey = async (
    projectKeyType: any,
    isAddYear?: boolean
  ) => {
    try {
      setGenerateProjectKeyLoading(true);
      const response = await axios.get(
        `tl-admin/project-key?projectKeyType=${projectKeyType}&addYear=${isAddYear}`
      );
      setFormValues((prevFormValues) => ({
        ...prevFormValues,
        projectKey: response.data.result,
      }));
      setGenerateProjectKeyLoading(false);
    } catch (err) {
      const error = getErrorMessage(err);
      setGenerateProjectKeyLoading(false);
      showError(error, toast);
    }
  };

  const fetchAllProjects = async () => {
    try {
      const response = await axios.get("tl-admin/project/all?page=-1");
      const newProjects = response.data.result.filter((project: any) => {
        return project.projectKey !== "TBC"; // Filter out projects with null projectKey
      });
      setAllProjects(newProjects);
    } catch (error) {
      const errorMessage = getErrorMessage(error);
      showError(errorMessage, toast);
    }
  };

  const fetchOHDProjects = async () => {
    try {
      const response = await axios.get("tl-admin/ohd-project");
      setAllOHDProjects(response.data.result);
    } catch (error) {
      const errorMessage = getErrorMessage(error);
      showError(errorMessage, toast);
    }
  };

  const fetchManagersList = async () => {
    try {
      const response = await axios.get("tl-admin/show-project-manager-list");
      setManagersList(
        response.data.result.filter(
          (manager: any) => manager.displayName !== "Not Required"
        )
      );
    } catch (err) {
      const error = getErrorMessage(err);
      showError(error, toast);
    }
  };

  const fetchManagers = async () => {
    try {
      const response = await axios.get("tl-admin/assigned-manager-list");
      setManagers(response.data.result);
    } catch (err) {
      const error = getErrorMessage(err);
      showError(error, toast);
    }
  };

  useEffect(() => {
    fetchProjectTypes();
    if (
      localStorage.roleName.includes(ROLES.TIMELOG_ADMIN) ||
      localStorage.roleName.includes(ROLES.SUPER_ADMIN) ||
      JSON.parse(localStorage.isProjectManager) === true
    ) {
      return;
    } else {
      navigate(localStorage.currentModuleUrl); // Redirect to the current module URL
    }
  }, []);

  useEffect(() => {
    setFirst(page);
    fetchManagersList();
    fetchManagers();
    fetchOHDProjects();
    fetchAllProjects();
    fetchProjects(page, size);
  }, [
    filters?.projectType,
    filters?.manager,
    statusFilter,
    sortFilter,
    searchProjectNameWithDebounce,
    searchProjectKeyWithDebounce,
  ]);

  const validateForm = () => {
    const errors: Partial<Record<string, string>> = {};

    if (!formValues.name || formValues.name.trim() === "") {
      errors.name = "Project name is required";
    }
    if (!formValues.projectKey || formValues.projectKey.trim() === "") {
      errors.projectKey = "Project key is required";
    }
    if (!formValues.projectKeyType || formValues.projectKeyType.trim() === "") {
      errors.projectKeyType = "Project key type is required";
    }
    if (!formValues.projectType || formValues.projectType.type.trim() === "") {
      errors.projectType = "Project type is required";
    }
    if (!formValues.startDate) {
      errors.startDate = "Start date is required";
    }
    // if (!formValues.endDate) {
    //   errors.endDate = "Finish date is required";
    // }
    // if (
    //   formValues.endDate &&
    //   (formValues.startDate > formValues.endDate ||
    //     formValues?.startDate > formValues?.endDate)
    // ) {
    //   errors.endDate = "End date should be greater than start date";
    //   errors.startDate = "Start date should not be greater than end date";
    //   showError("Start date should not be greater than end date", toast);
    // }
    if (!formValues.managers) {
      errors.managers = "Manager is required";
    }
    setFormErrors((prev) => ({ ...prev, ...errors }));

    return Object.keys(errors).length === 0; // Returns true if no errors
  };

  const handleAddUpdateProject = async (formType?: string) => {
    if (!validateForm()) return; // Stop submission if validation fails
    try {
      const projectData: any = {};
      setIsAddButtonDisabled(true);
      if (formType === "update" || formType === "copy") {
        projectData.projectID = formValues?.projectID;
      }
      projectData.name = formValues?.name?.trim();
      projectData.projectKey = formValues?.projectKey?.trim();
      projectData.startDate = formValues.startDate;
      // projectData.endDate = formValues.endDate;
      projectData.projectNotes = formValues?.projectNotes?.trim();
      projectData.projectTypeID = formValues.projectType.projectTypeID;
      projectData.addYear = formValues?.addYear;
      projectData.sendNewProjectCreationEmail =
        formValues?.sendNewProjectCreationEmail;
      projectData.managerID = formValues?.managers?.map(
        (manager: any) => manager.userID
      );

      formType === "add"
        ? await axios.post("tl-admin/add-project", projectData)
        : formType === "update"
        ? await axios.post("tl-admin/edit-project", projectData)
        : await axios.post("tl-admin/copy-project", projectData);
      setIsDialogVisible(false);
      setFormErrors({
        name: null,
        projectKey: null,
        projectKeyType: null,
        projectType: null,
        startDate: null,
        projectNotes: null,
        // endDate: null,
        managers: null,
        isActive: null,
      });
      setFormValues({
        name: null,
        projectKey: null,
        projectKeyType: null,
        projectType: null,
        addYear: false,
        sendNewProjectCreationEmail: false,
        startDate: null,
        projectNotes: null,
        // endDate: null,
        managers: null,
        isActive: formType === "add" ? true : formValues.isActive,
      });
      // setIsAddYearChecked(false);
      setSelectedManager(null); // Reset the selected manager
      setFirst(page);
      fetchManagersList();
      fetchManagers();
      fetchOHDProjects();
      fetchAllProjects();
      fetchProjects(page, size);
      setIsAddButtonDisabled(false);
    } catch (err) {
      const error = getErrorMessage(err);
      showError(error, toast);
      setIsAddButtonDisabled(false);
    }
  };

  const handleEditProject = (rowData: Project) => {
    setFormType("update");
    // Find the manager in the managersList array
    const manager = managersList.find(
      (user: any) => user.userID === rowData.managers[0]?.userID
    );

    if (rowData.projectKey && rowData.projectKey.startsWith("VEH")) {
      setSelectedProjectKeyType(projectKeyTypesObject.VEHICLE);
    } else if (rowData.projectKey && rowData.projectKey.startsWith("OHD")) {
      setSelectedProjectKeyType(projectKeyTypesObject.OVERHEAD);
    } else {
      setSelectedProjectKeyType(projectKeyTypesObject.GENERAL);
    }
    // Set the selected manager
    setSelectedManager(manager || null);
    setFormValues({
      projectID: rowData.projectID,
      name: rowData.name,
      projectKey: rowData.projectKey,
      projectKeyType:
        rowData.projectKey && rowData.projectKey.startsWith("VEH")
          ? "VEHICLE"
          : rowData.projectKey && rowData.projectKey.startsWith("OHD")
          ? "OVERHEAD"
          : "GENERAL",
      projectType: projectTypes.find(
        (projectType: any) => projectType.type === rowData.projectType
      ),
      addYear: false,
      sendNewProjectCreationEmail: false,
      startDate: rowData.startDate,
      projectNotes: rowData.projectNotes,
      // endDate: rowData.endDate,
      managers: rowData.managers,
      isActive: rowData.isActive,
    });
    setIsDialogVisible(true);
  };

  const updateProjectstatus = async (
    projectID: any,
    isActive: boolean,
    reason: string
  ) => {
    try {
      setIsAddButtonDisabled(true);
      setFormValues((prevFormValues) => ({
        ...prevFormValues,
        projectID,
      }));
      const statusResponse = await axios.post("tl-admin/edit-project", {
        projectID,
        isActive,
        statusChangeReason: reason,
      });
      if (statusResponse.status === 200) {
        showSuccess(statusResponse.data.Message, toast);
        const updatedProjects = projects.map((project) =>
          project.projectID === projectID
            ? { ...project, isActive: isActive }
            : project
        );
        setProjects(updatedProjects);
      } else {
        setIsAddButtonDisabled(false);
      }
      setIsAddButtonDisabled(false);
      // Reset status change states
      setIsStatusDialogVisible(false);
      setStatusChangeReason("");
      setPendingStatusChange(null);
    } catch (err) {
      const error = getErrorMessage(err);
      showError(error, toast);
      setIsAddButtonDisabled(false);
      setIsStatusDialogVisible(false);
      setStatusChangeReason("");
      setPendingStatusChange(null);
    }
  };

  const formatCreatedDate = (dateString: string) => {
    const date = new Date(dateString);

    const day = date.getUTCDate().toString().padStart(2, "0"); // 25
    const month = date.toLocaleString("en-UK", { month: "short" }); // Sep
    const year = date.getUTCFullYear(); // 2024

    const time = date.toLocaleTimeString("en-UK", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });

    return `${day} ${month} ${year} ${time}`;
  };

  const events: any = projectStatusChangeActivity?.map((activity: any) => {
    return {
      actionTakerID: activity?.actionTakerID,
      date: activity?.createdDate,
      actionTakerDisplayName: activity?.actionTakerName,
      comment: activity?.statusChangeReason,
      action:
        activity?.previousStatus && activity?.newStatus
          ? `Status changed from ${
              activity.previousStatus.charAt(0).toUpperCase() +
              activity.previousStatus.slice(1).toLowerCase()
            } to ${
              activity.newStatus.charAt(0).toUpperCase() +
              activity.newStatus.slice(1).toLowerCase()
            }`
          : null,
      id: activity?.id,
      previousStatus: activity?.previousStatus,
      newStatus: activity?.newStatus,
    };
  });

  const customizedMarker = () => {
    return (
      <>
        <div className="tw-flex tw-justify-center tw-items-center tw-w-5 tw-h-5 tw-rounded-full tw-bg-[#E2E8F0]">
          <div className="tw-w-3 tw-h-3 tw-rounded-full tw-bg-[#00AFEE]"></div>
        </div>
      </>
    );
  };

  const customizedContent = (item: any) => {
    return (
      <>
        {item?.action ? (
          <Card className={`activity-card tw-bg-gray-50`}>
            <div className="activity-container tw-flex tw-justify-between tw-items-center tw-mb-4">
              {/* <span className="po-number tw-text-ellipsis tw-overflow-hidden tw-max-w-52">
              {item?.status}
            </span> */}
              <span className="activity-date tw-text-ellipsis tw-overflow-hidden tw-max-w-52">
                {formatCreatedDate(item?.date)}
              </span>
            </div>
            <span className="activity-content tw-text-ellipsis tw-overflow-hidden tw-max-w-52">
              <span>
                <span className="tw-font-medium tw-text-gray-700">
                  {item?.action}
                </span>{" "}
                <span className="tw-text-gray-600">
                  by {item?.actionTakerDisplayName}
                </span>
              </span>
            </span>
            <div className="tw-flex tw-justify-between tw-items-center tw-mt-1 tw-font-medium tw-text-[#6611119c]">
              <span className="tw-ml-auto">{item?.comment}</span>
            </div>
          </Card>
        ) : (
          <>
            <div>No History Found</div>
          </>
        )}
      </>
    );
  };

  const getOriginalDate = (date: string | null): Date | null => {
    if (!date) return null;
    const formattedDate = convertEpochtoDate(date, "getDateValue");
    const dateObject = new Date(formattedDate + "T00:00:00");
    return dateObject;
  };

  const InvoiceDateConst = (date: any, type: string): void | null => {
    if (!date) return null;

    const formattedDate = Math.floor(date.getTime() / 1000.0);

    if (type === "startDate") {
      setFormValues((prevFormValues: Project) => ({
        ...prevFormValues,
        startDate: formattedDate,
      }));
      // if (formValues?.endDate && formattedDate < formValues?.endDate) {
      //   setFormErrors((prevFormErrors: FormErrors) => ({
      //     ...prevFormErrors,
      //     endDate: null,
      //   }));
      // }

      setFormErrors((prevFormErrors: FormErrors) => ({
        ...prevFormErrors,
        startDate: null,
      }));
    }
    // else {
    //   setFormValues((prevFormValues: Project) => ({
    //     ...prevFormValues,
    //     endDate: formattedDate,
    //   }));
    //   if (formValues?.startDate && formattedDate > formValues?.startDate) {
    //     setFormErrors((prevFormErrors: FormErrors) => ({
    //       ...prevFormErrors,
    //       startDate: null,
    //     }));
    //   }
    //   setFormErrors((prevFormErrors: FormErrors) => ({
    //     ...prevFormErrors,
    //     endDate: null,
    //   }));
    // }
  };

  const onPageChange = (event: PaginatorPageChangeEvent) => {
    setFirst(event.first);
    setSize(event.rows); // Set the number of rows per page
    const currentPage = Math.floor(event.first / event.rows); // Calculate the current page index
    fetchProjects(currentPage, event.rows);
  };

  const headerTemplate = (header: string, field: string) => {
    return (
      <div
        className={`tw-flex tw-justify-between tw-w-full tw-items-center ${
          field !== "" && "tw-cursor-pointer"
        }`}
        onClick={() => {
          if (field !== "") {
            setSortFilter((prevSortFilter: any) => ({
              ...prevSortFilter,
              sortField: field,
              sortOrder: !prevSortFilter.sortOrder,
            }));
          }
        }}
      >
        <span className="tw-font-bold">{header}</span>
        {field !== "" && (
          <span className="tw-ml-4 tw-mr-0">
            <TableSortingSVG />
          </span>
        )}
      </div>
    );
  };

  // const projectNameTemplate = (rowData: Project) => (
  //   <div>
  //     <span>
  //       {rowData.name} - {`( ${rowData.projectKey} )`}
  //     </span>
  //   </div>
  // );

  const managersTemplate = (rowData: Project) => (
    <div>
      {rowData.managers.map((manager: any) => (
        <div key={manager.userID} className="tw-flex tw-gap-2">
          <span>{manager.displayName}</span>
        </div>
      ))}
    </div>
  );

  const dateTemplate = (rowData: Project, type: string) => {
    return (
      <div>
        <span>
          {rowData.startDate ? convertEpochtoDate(rowData.startDate) : ""}
        </span>
      </div>
    );
  };

  const handleStatusChangeClick = (
    projectID: number,
    currentStatus: boolean
  ) => {
    setPendingStatusChange({
      projectID,
      isActive: !currentStatus,
    });
    setStatusChangeReason("");
    setIsStatusDialogVisible(true);
  };

  const confirmStatusChange = () => {
    if (!statusChangeReason.trim()) {
      // showError("Please provide a reason for the status change", toast);
      setStatusChangeReasonError(
        "Please provide a reason for the status change"
      );
      return;
    }
    setStatusChangeReasonError(null);
    if (pendingStatusChange) {
      updateProjectstatus(
        pendingStatusChange.projectID,
        pendingStatusChange.isActive,
        statusChangeReason
      ).then(() => {
        fetchProjects(page, size);
        setIsStatusDialogVisible(false);
      });
    }
  };

  const actionBodyTemplate = (rowData: Project) => (
    <div className="tw-flex tw-gap-4">
      <Button
        className="p-button-rounded tw-p-0 tw-w-auto tw-h-auto"
        onClick={() => handleEditProject(rowData)}
      >
        <EditButtonSVG />
      </Button>
      <InputSwitch
        checked={rowData.isActive}
        onChange={(e: InputSwitchChangeEvent) => {
          // updateProjectstatus(rowData.projectID, e.value);
          handleStatusChangeClick(rowData.projectID!, rowData.isActive);
        }}
        disabled={
          isAddButtonDisabled && rowData.projectID === formValues.projectID
        }
      />
      <Button
        className="p-button-rounded tw-p-0 tw-w-auto tw-h-auto focus:tw-shadow-none"
        onClick={() => {
          setProjectStatusChangeActivity(
            rowData?.projectStatusChangeHistory || []
          );
          setSelectedRowData(rowData);
          setViewHistoryPopup(true);
        }}
        tooltip="View Status History"
        tooltipOptions={{ position: "top" }}
      >
        <i className="pi pi-info-circle tw-text-[#00AFEE] tw-text-xl"></i>
      </Button>
    </div>
  );

  const handleSelectProjectToCopy = async (project: any) => {
    const projectToCopy = await allOHDProjects.find(
      (proj: any) => proj.projectID === project.projectID
    );
    if (
      projectToCopy.projectKey &&
      projectToCopy.projectKey.startsWith("VEH")
    ) {
      setSelectedProjectKeyType(projectKeyTypesObject.VEHICLE);
    } else if (
      projectToCopy.projectKey &&
      projectToCopy.projectKey.startsWith("OHD")
    ) {
      setSelectedProjectKeyType(projectKeyTypesObject.OVERHEAD);
    } else {
      setSelectedProjectKeyType(projectKeyTypesObject.GENERAL);
    }
    // Find the manager in the managersList array
    const manager = managersList.find(
      (user: any) => user.userID === projectToCopy?.managers[0]?.userID
    );
    // Set the selected manager
    setSelectedManager(manager || null);
    setFormValues({
      projectID: projectToCopy.projectID,
      name: projectToCopy.name,
      projectKey: projectToCopy.projectKey,
      projectKeyType:
        projectToCopy.projectKey && projectToCopy.projectKey.startsWith("VEH")
          ? "VEHICLE"
          : projectToCopy.projectKey &&
            projectToCopy.projectKey.startsWith("OHD")
          ? "OVERHEAD"
          : "GENERAL",
      projectType: projectTypes.find(
        (projectType: any) => projectType.type === projectToCopy.projectType
      ),
      startDate: projectToCopy.startDate,
      addYear: projectToCopy.addYear,
      sendNewProjectCreationEmail: false,
      projectNotes: projectToCopy.projectNotes,
      // endDate: projectToCopy.endDate,
      managers: projectToCopy.managers,
      isActive: projectToCopy.isActive,
    });
  };

  const projectColumns: ColumnOption[] = [
    {
      field: "projectKey",
      header: headerTemplate("Project Key", ""),
      // body: projectNameTemplate,
      visible: true,
    },
    {
      field: "name",
      header: headerTemplate("Project Name", ""),
      // body: projectNameTemplate,
      visible: true,
    },
    {
      field: "projectType",
      header: headerTemplate("Project Type", ""),
      // body: projectNameTemplate,
      visible: true,
    },
    {
      field: "startDate",
      header: headerTemplate("Start Date", ""),
      body: (rowData: any) => dateTemplate(rowData, "startDate"),
      visible: true,
    },
    // {
    //   field: "endDate",
    //   header: headerTemplate("Finish Date", ""),
    //   body: (rowData: any) => dateTemplate(rowData, "endDate"),
    //   visible: true,
    // },
    {
      field: "managers",
      header: headerTemplate("Manager", ""),
      body: managersTemplate,
      visible: true,
    },
    ...(localStorage.roleName.includes(ROLES.TIMELOG_ADMIN) ||
    localStorage.roleName.includes(ROLES.SUPER_ADMIN)
      ? [
          {
            field: "action",
            header: headerTemplate("Action", ""),
            body: actionBodyTemplate,
            visible: true,
          },
        ]
      : []),
  ];

  const clearFilters = () => {
    setStatusFilter("all");
    setSelectedProjectName(null);
    setSelectedProjectKey(null);
    setSelectedProjectType(null);
    setSelectedManager(null);
    setFilters((prevFilters) => ({
      ...prevFilters,
      projectID: null,
      name: null,
      projectKey: null,
      projectType: null,
      manager: null,
      status: "all",
    }));
  };

  const items = [
    {
      items: [
        {
          template: (
            <div className="tw-flex tw-flex-col tw-gap-2 tw-mx-5 tw-w-62 tw-mt-3 tw-mb-5">
              <label htmlFor="projectName">Project Name</label>
              <div className="tw-relative tw-w-full">
                {/* <Dropdown
                className="tw-h-11 tw-border tw-border-solid tw-border-gray-300 tw-rounded-md tw-w-full placeholder:tw-font-normal filter-dropdown"
                value={selectedProjectName}
                options={allProjects}
                optionLabel="name" // Assuming 'roles' contains an array of objects with a 'role' key
                placeholder="Select Project Name"
                onChange={(e) => {
                  setSelectedProjectName(
                    allProjects.find(
                      (project: any) => project.name === e.target.value.name
                    )
                  );
                  setFilters((prevFilters) => ({
                    ...prevFilters,
                    name: e.target.value.name,
                    projectID: e.target.value.projectID,
                  }));
                }}
                onClick={(e) => e.stopPropagation()}
                filter
              /> */}
                <AutoComplete
                  className={`${
                    formErrors.name ? "tw-border-red-600" : "tw-border-gray-300"
                  } tw-px-[14px] tw-py-[5px] tw-border tw-border-solid tw-border-gray-300 tw-rounded-md tw-h-11 placeholder:tw-font-normal`}
                  value={selectedProjectName}
                  suggestions={projectNamesuggestions}
                  completeMethod={(e) => {
                    const query = e.query.toLowerCase();
                    const filtered = allProjects.filter((project: any) =>
                      project.name.toLowerCase().includes(query)
                    );
                    if (filtered.length === 0) {
                      setProjectNameSuggestions([
                        {
                          name: "No records found",
                          projectID: null,
                          disabled: true,
                        },
                      ]);
                    } else {
                      setProjectNameSuggestions(filtered);
                    }
                  }}
                  field="name"
                  placeholder="Search Project Name"
                  onChange={(e) => {
                    // Check if e.value is a string (manual typing) or an object (selection from dropdown)
                    if (typeof e.value === "string") {
                      setSelectedProjectName(e.value);
                      setFilters((prevFilters) => ({
                        ...prevFilters,
                        name: e.value || null,
                        projectID: null,
                      }));
                    } else {
                      setSelectedProjectName(e.value);
                      setFilters((prevFilters) => ({
                        ...prevFilters,
                        name: e.value?.name || null,
                        projectID: e.value?.projectID || null,
                      }));
                    }
                  }}
                  onClick={(e) => e.stopPropagation()}
                  // Explicitly handle input events
                  inputRef={(el) => {
                    if (el) {
                      el.addEventListener("keydown", (e) => {
                        // Prevent any default handling of space that might be causing issues
                        if (e.key === " " || e.code === "Space") {
                          e.stopPropagation();
                        }
                      });
                    }
                  }}
                  // Make sure the component doesn't filter out spaces
                  forceSelection={false}
                  panelClassName="tw-w-full tw-mt-[11px]"
                  // panelStyle={{ width: '100%' }}
                  appendTo="self"
                />
              </div>
            </div>
          ),
        },
        {
          template: (
            <div className="tw-flex tw-flex-col tw-gap-2 tw-mx-5 tw-w-62 tw-mt-3 tw-mb-5">
              <label htmlFor="projectName">Project Key</label>
              <div className="tw-relative tw-w-full">
                <AutoComplete
                  id="projectKey"
                  className={`${
                    formErrors.projectKey
                      ? "tw-border-red-600"
                      : "tw-border-gray-300"
                  } tw-px-4 tw-py-1 tw-border tw-border-solid tw-border-gray-300 tw-rounded-md tw-h-11 placeholder:tw-font-normal tw-w-full`}
                  value={selectedProjectKey}
                  suggestions={projectKeysuggestions}
                  completeMethod={(e) => {
                    const query = e.query.toLowerCase();
                    const filtered = allProjects.filter((project: any) =>
                      project.projectKey.toLowerCase().includes(query)
                    );
                    setProjectKeySuggestions(filtered);
                  }}
                  field="projectKey"
                  placeholder="Search Project Key"
                  onChange={(e) => {
                    if (typeof e.value === "string") {
                      setSelectedProjectKey(e.value);
                      setFilters((prevFilters) => ({
                        ...prevFilters,
                        projectKey: e.value || null,
                      }));
                    } else {
                      setSelectedProjectKey(e.value);
                      setFilters((prevFilters) => ({
                        ...prevFilters,
                        projectKey: e.value?.projectKey || null,
                      }));
                    }
                  }}
                  onClick={(e) => e.stopPropagation()}
                  panelClassName="tw-w-full tw-mt-[11px]"
                  // panelStyle={{ width: '100%' }}
                  appendTo="self"
                />
              </div>
            </div>
          ),
        },
        {
          template: (
            <div className="tw-flex tw-flex-col tw-gap-2 tw-mx-5 tw-w-62 tw-mt-3 tw-mb-5">
              <label htmlFor="projectName">Project Type</label>
              <Dropdown
                className="tw-h-11 tw-border tw-border-solid tw-border-gray-300 tw-rounded-md tw-w-full placeholder:tw-font-normal filter-dropdown"
                value={selectedProjectType ?? null}
                options={projectTypes}
                optionLabel="type"
                placeholder="Select Project Type"
                onChange={(e) => {
                  setSelectedProjectType(e.target.value);
                  setFilters((prevFilters) => ({
                    ...prevFilters,
                    projectType: e.target.value,
                  }));
                }}
                onClick={(e) => e.stopPropagation()}
                // filter
              />
            </div>
          ),
        },
        {
          template: (
            <div className="tw-flex tw-flex-col tw-gap-2 tw-mx-5 tw-w-62 tw-mt-3 tw-mb-5">
              <label htmlFor="manager">Manager</label>
              <Dropdown
                className="tw-h-11 tw-border tw-border-solid tw-border-gray-300 tw-rounded-md tw-w-full placeholder:tw-font-normal filter-dropdown"
                value={filters?.manager ?? null}
                options={managers}
                optionLabel="displayName"
                placeholder="Select a Manager"
                onChange={(e) => {
                  setFilters((prevFilters) => ({
                    ...prevFilters,
                    manager: e.target.value,
                  }));
                }}
                filter
                onClick={(e) => e.stopPropagation()}
                // filter
              />
            </div>
          ),
        },
        {
          template: (
            <div className="tw-flex tw-flex-wrap tw-gap-3 tw-items-center tw-mx-7 tw-w-62 tw-mt-5 tw-mb-3">
              {STATUS_FILTER.map((status) => (
                <div key={status.id} className="tw-flex tw-items-center">
                  <RadioButton
                    key={status.id}
                    inputId={status.id}
                    value={status.value}
                    checked={statusFilter === status.value}
                    onChange={(e) =>
                      setStatusFilter(e.value as "all" | "active" | "inactive")
                    }
                  />
                  <label htmlFor={status.id} className="tw-ml-1">
                    {status.label}
                  </label>
                </div>
              ))}
            </div>
          ),
        },
        {
          template: (
            <div className="tw-flex tw-flex-col tw-gap-2 tw-mx-5 tw-w-62 tw-mt-3 tw-mb-4">
              <Button
                className="tw-flex tw-px-3 tw-py-2 tw-rounded tw-bg-red-500 hover:tw-bg-red-500 tw-font-medium tw-gap-2 tw-text-white"
                onClick={clearFilters} // This function will reset filters
              >
                Clear Filters
              </Button>
            </div>
          ),
        },
      ],
    },
  ];

  return (
    <>
      <Toast ref={toast} />
      <div className="card">
        <div className="tw-flex tw-justify-between tw-items-center tw-w-full tw-gap-4 tw-bg-[#F8FAFC] tw-p-4 tw-mr-4">
          <h1 className="tw-font-bold tw-text-xl">Project Listing</h1>

          <div className="tw-flex tw-gap-2 focus:tw-shadow-none">
            <FilterButton menu={menu} />

            <Menu
              className="tw-w-72"
              model={items as MenuItem[]}
              popup
              ref={menu}
            />

            {(localStorage.roleName.includes(ROLES.TIMELOG_ADMIN) ||
              localStorage.roleName.includes(ROLES.SUPER_ADMIN)) && (
              <>
                <Button
                  className="tw-flex tw-px-3 tw-py-2 tw-rounded bg-primary border-primary tw-text-white tw-font-medium focus:tw-shadow-none hover:tw-bg-[#02a2db]"
                  label="Add Project"
                  icon="pi pi-plus"
                  onClick={() => {
                    setFormValues({
                      name: null,
                      projectKey: null,
                      projectKeyType: null,
                      projectType: null,
                      addYear: false,
                      sendNewProjectCreationEmail: false,
                      startDate: null,
                      projectNotes: null,
                      // endDate: null,
                      managers: null,
                      isActive: true,
                    });
                    setFormType("add");
                    setSelectedProjectKeyType(null);
                    setIsDialogVisible(true);
                  }}
                />
                <Button
                  className="tw-flex tw-px-3 tw-py-2 tw-rounded bg-secondary hover:tw-bg-[#3f3c3c] border-primary tw-text-white tw-font-medium focus:tw-shadow-none"
                  label="Copy Project"
                  icon="pi pi-copy"
                  onClick={() => {
                    setFormValues({
                      name: null,
                      projectKey: null,
                      projectKeyType: null,
                      projectType: null,
                      addYear: false,
                      sendNewProjectCreationEmail: false,
                      startDate: null,
                      projectNotes: null,
                      // endDate: null,
                      managers: null,
                      isActive: true,
                    });
                    setFormType("copy");
                    setSelectedProjectKeyType(null);
                    setShowProjectDetailsToCopy(false);
                    setIsDialogVisible(true);
                  }}
                />
                <Button
                  type="button"
                  icon="pi pi-upload"
                  label="Export"
                  loading={isExporting}
                  className="tw-flex tw-px-9 tw-py-2 tw-rounded bg-secondary border-primary hover:tw-bg-[#3f3c3c] tw-text-white tw-font-medium focus:tw-shadow-none"
                  onClick={() => fetchProjects(page, size, "export")}
                />
              </>
            )}
          </div>
        </div>
        <div className="card-body tw-relative tw-min-h-80 table-p-0">
          {projectsLoading ? (
            <div className="tw-h-full tw-w-full tw-bg-white tw-flex tw-justify-center tw-items-center tw-absolute tw-top-0 tw-left-0 tw-z-50">
              <ProgressSpinner />
            </div>
          ) : (
            <>
              <DataTableComponent
                rowData={projects}
                columns={projectColumns}
                customClass="timelog-datatable"
              />

              <Paginator
                first={first}
                rows={size}
                totalRecords={totalRecords} // Set total records for pagination
                rowsPerPageOptions={[5, 10, 25, 50]}
                onPageChange={onPageChange}
              />
            </>
          )}
        </div>
      </div>
      <Dialog
        header={
          formType === "add"
            ? "Add Project"
            : formType === "copy"
            ? "Copy Project"
            : "Update Project"
        }
        draggable={false}
        visible={isDialogVisible}
        style={{ width: "28vw" }}
        onHide={() => {
          if (!isDialogVisible) return;
          setIsDialogVisible(false);
          setFormErrors((prevFormErrors) => ({
            ...prevFormErrors,
            name: null,
            projectKey: null,
            projectKeyType: null,
            projectType: null,
            startDate: null,
            endDate: null,
            managers: null,
          }));
          setFormValues((prevFormValues) => ({
            ...prevFormValues,
            name: null,
            projectKey: null,
            addYear: false,
            sendNewProjectCreationEmail: false,
            projectKeyType: null,
            projectType: null,
            startDate: null,
            endDate: null,
            managers: null,
          }));
          setSelectedProjectKeyType(null);
          setSelectedManager(null); // Reset the selected manager
          setFormType("add");
          setShowProjectDetailsToCopy(true);
        }}
      >
        <>
          {generateProjectKeyLoading && (
            <div className="tw-h-full tw-w-full tw-bg-transparent tw-flex tw-justify-center tw-items-center tw-absolute tw-top-0 tw-left-0 tw-z-50">
              <ProgressSpinner />
            </div>
          )}
          <div>
            {!showProjectDetailsToCopy && (
              <div className="tw-mt-3 tw-flex tw-flex-col tw-gap-2">
                <label className="tw-mt-3 tw-font-bold">Projects</label>
                <Dropdown
                  value={selectedManager}
                  onChange={(e) => {
                    setFormErrors((prevErrors) => ({
                      ...prevErrors,
                      managers: null,
                    }));
                    setSelectedManager(e.target.value); // Update the selected manager
                    setFormValues((prevFormValues) => ({
                      ...prevFormValues,
                      // managers: [...(prevFormValues.managers || []), e.target.value],
                      managers: [e.target.value],
                    }));
                    setShowProjectDetailsToCopy(true);
                    handleSelectProjectToCopy(e.target.value);
                    // setFormType("update")
                  }}
                  filterBy="projectKey,name"
                  filter
                  options={allOHDProjects}
                  optionLabel="projectKey"
                  placeholder="Select a Project"
                  className={`tw-border tw-border-solid ${
                    formErrors.managers
                      ? "tw-border-red-600"
                      : "tw-border-gray-300"
                  } tw-border-gray-300 tw-rounded-md placeholder:tw-font-normal tw-w-full`}
                />
              </div>
            )}
            {showProjectDetailsToCopy && (
              <div className="tw-flex tw-flex-col">
                <div className="tw-mt-0 tw-flex tw-flex-col tw-gap-2">
                  <label className="tw-font-bold">Project Name</label>
                  <InputText
                    value={formValues?.name ?? ""}
                    className={`${
                      formErrors.name
                        ? "tw-border-red-600"
                        : "tw-border-gray-300"
                    } tw-px-[14px] tw-py-[5px] tw-border tw-border-solid tw-border-gray-300 tw-rounded-md tw-h-11 placeholder:tw-font-normal`}
                    onChange={(e) => {
                      setFormErrors((prevErrors) => ({
                        ...prevErrors,
                        name: null,
                      }));
                      e.target.value === ""
                        ? setFormValues((prevFormValues) => ({
                            ...prevFormValues,
                            name: null,
                          }))
                        : setFormValues((prevFormValues) => ({
                            ...prevFormValues,
                            name: e.target.value,
                          }));
                    }}
                    readOnly={formType === "copy"}
                    placeholder="Enter Project Name"
                  />
                </div>

                <div className="tw-mt-3 tw-flex tw-gap-2 tw-w-full">
                  {/* Project Key Type - 40% Width */}
                  <div className="tw-w-[40%]">
                    <label className="tw-font-bold tw-text-">
                      Project Category
                    </label>
                    <>
                      {formType === "add" ? (
                        <Dropdown
                          value={selectedProjectKeyType ?? ""}
                          // disabled={formType === "update"}
                          onChange={(e) => {
                            setFormErrors((prevErrors) => ({
                              ...prevErrors,
                              projectKeyType: null,
                            }));
                            setSelectedManager(e.target.value);
                            setFormValues((prevFormValues) => ({
                              ...prevFormValues,
                              projectKeyType: e.target.value,
                            }));
                            setSelectedProjectKeyType(e.target.value);
                            generateProjectKey(
                              e.target.value,
                              isAddYearChecked
                            );
                          }}
                          options={projectKeyTypes}
                          optionLabel="label"
                          placeholder="Select Project Key Type"
                          className={`tw-border tw-border-solid ${
                            formErrors.projectKeyType
                              ? "tw-border-red-600"
                              : "tw-border-gray-300"
                          } tw-border-gray-300 tw-rounded-md placeholder:tw-font-normal tw-w-full tw-h-[45px]`}
                        />
                      ) : (
                        <InputText
                          value={selectedProjectKeyType ?? ""}
                          readOnly
                          className={`
                    ${
                      formErrors.projectKeyType
                        ? "tw-border-red-600"
                        : "tw-border-gray-300"
                    } 
                      tw-px-[14px] tw-py-[5px] tw-border tw-border-solid tw-border-gray-300 tw-rounded-md tw-h-11 placeholder:tw-font-normal tw-w-full`}
                        />
                      )}
                    </>
                  </div>
                  {/* Project Key - 60% Width */}
                  <div className="tw-w-[60%] tw-cursor-default">
                    <div className="tw-flex tw-justify-between tw-gap-2">
                      {" "}
                      <label className="tw-mt- tw-font-bold">Project Key</label>
                      {formType === "add" &&
                        formValues?.projectKeyType === "GENERAL" && (
                          <div className={`tw-mt- tw-mr-[5px]`}>
                            <Checkbox
                              inputId="terms"
                              checked={isAddYearChecked ?? false}
                              onChange={(e) => {
                                setFormValues((prevFormValues: any) => ({
                                  ...prevFormValues,
                                  addYear: e.checked,
                                }));
                                setIsAddYearChecked(e.checked);
                                generateProjectKey(
                                  selectedProjectKeyType,
                                  e.checked
                                );
                              }}
                              className="tw-mr-2 tw-border tw-rounded-md"
                              disabled={false}
                            />
                            <label className="tw-font-semibold">
                              Add Year?
                            </label>
                          </div>
                        )}
                    </div>
                    <InputText
                      value={formValues?.projectKey ?? ""}
                      placeholder="Project Key"
                      readOnly
                      keyfilter="alphanum"
                      onChange={(e) => {
                        setFormErrors((prevErrors) => ({
                          ...prevErrors,
                          projectKey: null,
                        }));
                        e.target.value === ""
                          ? setFormValues((prevFormValues) => ({
                              ...prevFormValues,
                              projectKey: null,
                            }))
                          : setFormValues((prevFormValues) => ({
                              ...prevFormValues,
                              projectKey: e.target.value,
                            }));
                      }}
                      className={`
                    ${
                      formErrors.projectKeyType
                        ? "tw-border-red-600"
                        : "tw-border-gray-300"
                    } 
                      tw-px-[14px] tw-py-[5px] tw-border tw-border-solid tw-border-gray-300 tw-rounded-md tw-h-11 placeholder:tw-font-normal tw-w-full`}
                    />
                  </div>
                </div>

                <div className="tw-mt-3">
                  <div className="tw-flex tw-flex-col tw-gap-2">
                    {" "}
                    <div className="tw-flex tw-justify-between">
                      <label className="tw-mt-3 tw-font-bold">
                        Project Type
                      </label>
                      {formType === "add" && (
                        <div className={`tw-mt-3 tw-mr-[2px]`}>
                          <Checkbox
                            inputId="terms"
                            checked={
                              formValues?.sendNewProjectCreationEmail ?? false
                            }
                            onChange={(e) => {
                              setFormValues((prevFormValues: any) => ({
                                ...prevFormValues,
                                sendNewProjectCreationEmail: e.checked,
                              }));
                            }}
                            className="tw-mr-2 tw-border tw-rounded-md"
                            disabled={false}
                          />
                          <label className="tw-font-semibold">
                            Send Email?
                          </label>
                        </div>
                      )}
                    </div>
                    {formType === "copy" ? (
                      <InputText
                        value={formValues?.projectType?.type ?? ""}
                        readOnly
                        className={`
                      ${
                        formErrors.projectType
                          ? "tw-border-red-600"
                          : "tw-border-gray-300"
                      } 
                        tw-px-[14px] tw-py-[5px] tw-border tw-border-solid tw-border-gray-300 tw-rounded-md tw-h-11 placeholder:tw-font-normal tw-w-full`}
                      />
                    ) : (
                      <Dropdown
                        value={formValues?.projectType ?? ""}
                        onChange={(e) => {
                          setFormErrors((prevErrors) => ({
                            ...prevErrors,
                            projectType: null,
                          }));
                          setFormValues((prevFormValues) => ({
                            ...prevFormValues,
                            projectType: e.target.value,
                          }));
                        }}
                        options={projectTypes}
                        optionLabel="type"
                        placeholder="Select project type"
                        className={`tw-border tw-border-solid ${
                          formErrors.projectType
                            ? "tw-border-red-600"
                            : "tw-border-gray-300"
                        } tw-border-gray-300 tw-rounded-md placeholder:tw-font-normal tw-w-full`}
                      />
                    )}
                  </div>
                </div>
                <div
                  className="tw-mt-3 tw-flex tw-flex-col tw-gap-2"
                  onClick={(e) => e.stopPropagation()} // Prevents the menu from closing
                >
                  <label
                    htmlFor="InvoiceDate"
                    className="tw-mt-3 tw-w-1/2 tw-font-bold"
                  >
                    Start Date
                  </label>
                  {formType === "copy" ? (
                    <InputText
                      value={convertEpochtoDate(formValues?.startDate)}
                      readOnly
                      className={`
                    ${
                      formErrors.startDate
                        ? "tw-border-red-600"
                        : "tw-border-gray-300"
                    } 
                      tw-px-[14px] tw-py-[5px] tw-border tw-border-solid tw-border-gray-300 tw-rounded-md tw-h-11 placeholder:tw-font-normal tw-w-full`}
                    />
                  ) : (
                    <Calendar
                      className={`${
                        formErrors.startDate
                          ? "tw-border-red-600"
                          : "tw-border-gray-300"
                      } tw-px-[14px] tw-py-[5px] tw-border tw-border-solid tw-border-gray-300 tw-rounded-md tw-h-11 placeholder:tw-font-normal`}
                      dateFormat="dd-mm-yy"
                      value={getOriginalDate(formValues?.startDate) as any}
                      placeholder="e.g. 01-01-2023"
                      // maxDate={
                      //   formValues?.endDate
                      //     ? (getOriginalDate(formValues?.endDate) as any)
                      //     : new Date()
                      // }
                      minDate={
                        new Date(new Date().setMonth(new Date().getMonth() - 1))
                      }
                      onChange={(e) => {
                        e.stopPropagation();
                        InvoiceDateConst(e.value, "startDate");
                      }}
                      showIcon
                      readOnlyInput={false} // Allow typing
                      onInput={(e: any) => {
                        const inputValue = e.target.value;
                        const dateRegex = /^\d{2}-\d{2}-\d{4}$/; // Regex for dd-mm-yyyy format
                        if (dateRegex.test(inputValue)) {
                          const [day, month, year] = inputValue
                            .split("-")
                            .map(Number);
                          const typedDate = new Date(year, month - 1, day);
                          if (!isNaN(typedDate.getTime())) {
                            InvoiceDateConst(typedDate, "startDate");
                          }
                        }
                      }}
                    />
                  )}
                </div>
                {/* <div
                  className="tw-mt-3 tw-flex tw-flex-col tw-gap-2"
                  onClick={(e) => e.stopPropagation()} // Prevents the menu from closing
                >
                  <label
                    htmlFor="InvoiceDate"
                    className="tw-mt-3 tw-w-1/2 tw-font-bold"
                  >
                    Finish Date
                  </label>
                  {formType === "copy" ? (
                    <InputText
                      value={convertEpochtoDate(formValues?.endDate)}
                      readOnly
                      className={`
                    ${
                      formErrors.endDate
                        ? "tw-border-red-600"
                        : "tw-border-gray-300"
                    } 
                      tw-px-[14px] tw-py-[5px] tw-border tw-border-solid tw-border-gray-300 tw-rounded-md tw-h-11 placeholder:tw-font-normal tw-w-full`}
                    />
                  ) : (
                    <Calendar
                      className={`${
                        formErrors.endDate
                          ? "tw-border-red-600"
                          : "tw-border-gray-300"
                      } tw-px-[14px] tw-py-[5px] tw-border tw-border-solid tw-border-gray-300 tw-rounded-md tw-h-11 placeholder:tw-font-normal`}
                      dateFormat="dd-mm-yy"
                      value={getOriginalDate(formValues?.endDate) as any}
                      placeholder="
                        e.g. 01-01-2023"
                      // maxDate={new Date()}
                      minDate={getOriginalDate(formValues?.startDate) as any}
                      onChange={(e) => {
                        e.stopPropagation();
                        // setResetPageNo(true);
                        InvoiceDateConst(e.value, "endDate");
                      }}
                      showIcon
                      readOnlyInput={false} // Allow typing
                      onInput={(e: any) => {
                        const inputValue = e.target.value;
                        const dateRegex = /^\d{2}-\d{2}-\d{4}$/; // Regex for dd-mm-yyyy format
                        if (dateRegex.test(inputValue)) {
                          const [day, month, year] = inputValue
                            .split("-")
                            .map(Number);
                          const typedDate = new Date(year, month - 1, day);
                          if (!isNaN(typedDate.getTime())) {
                            InvoiceDateConst(typedDate, "endDate");
                          }
                        }
                      }}
                    />
                  )}
                </div> */}
                <div className="tw-mt-3 tw-flex tw-flex-col tw-gap-2">
                  <label className="tw-mt-3 tw-font-bold">Manager</label>
                  {formType === "copy" ? (
                    <InputText
                      value={selectedManager?.displayName ?? ""}
                      readOnly
                      className={`
                          ${
                            formErrors.managers
                              ? "tw-border-red-600"
                              : "tw-border-gray-300"
                          } 
                            tw-px-[14px] tw-py-[5px] tw-border tw-border-solid tw-border-gray-300 tw-rounded-md tw-h-11 placeholder:tw-font-normal tw-w-full`}
                    />
                  ) : (
                    <Dropdown
                      value={selectedManager}
                      onChange={(e) => {
                        setFormErrors((prevErrors) => ({
                          ...prevErrors,
                          managers: null,
                        }));
                        setSelectedManager(e.target.value); // Update the selected manager
                        setFormValues((prevFormValues) => ({
                          ...prevFormValues,
                          // managers: [...(prevFormValues.managers || []), e.target.value],
                          managers: [e.target.value],
                        }));
                      }}
                      filter
                      options={managersList}
                      optionLabel="displayName"
                      placeholder="Select a Manager"
                      className={`tw-border tw-border-solid ${
                        formErrors.managers
                          ? "tw-border-red-600"
                          : "tw-border-gray-300"
                      } tw-border-gray-300 tw-rounded-md placeholder:tw-font-normal tw-w-full`}
                    />
                  )}
                </div>

                <div className="adminnotes tw-mt-2">
                  <div className="tw-flex tw-flex-col tw-gap-2">
                    <label
                      htmlFor="projectNotes"
                      className="tw-mt-3 tw-font-semibold"
                    >
                      Notes
                    </label>
                    <InputText
                      type="text"
                      className={`tw-px-[14px] tw-py-[5px] tw-border tw-border-solid tw-border-gray-300 tw-rounded-md tw-h-11 placeholder:tw-font-normal`}
                      placeholder="Enter Project Notes"
                      id="projectNotes"
                      aria-describedby="Project-Notes-help"
                      readOnly={formType === "copy"}
                      value={formValues?.projectNotes ?? ""}
                      onChange={(e) => {
                        setFormErrors((prevErrors) => ({
                          ...prevErrors,
                          projectNotes: null,
                        }));
                        e.target.value === ""
                          ? setFormValues((prevFormValues) => ({
                              ...prevFormValues,
                              projectNotes: null,
                            }))
                          : setFormValues((prevFormValues) => ({
                              ...prevFormValues,
                              projectNotes: e.target.value,
                            }));
                      }}
                    />
                  </div>
                </div>

                <Button
                  label={
                    formType === "add"
                      ? "Add Project"
                      : formType === "copy"
                      ? "Copy Project"
                      : "Update Project"
                  }
                  className="tw-flex tw-px-3 tw-py-2 tw-rounded-lg focus:tw-shadow-none bg-primary border-primary tw-text-white tw-font-medium tw-w-full tw-mt-8"
                  onClick={() => {
                    handleAddUpdateProject(formType);
                  }}
                  disabled={isAddButtonDisabled}
                />
              </div>
            )}
          </div>
        </>
      </Dialog>
      <Dialog
        header={`${
          pendingStatusChange?.isActive ? "Activate" : "Deactivate"
        } Project`}
        draggable={false}
        visible={isStatusDialogVisible}
        style={{ width: "28vw" }}
        onHide={() => {
          setIsStatusDialogVisible(false);
          setStatusChangeReason("");
          setPendingStatusChange(null);
        }}
      >
        <div className="tw-flex tw-flex-col tw-gap-4">
          <p>
            Please provide a reason for{" "}
            {pendingStatusChange?.isActive ? "activating" : "deactivating"} this
            project:
          </p>
          <InputText
            value={statusChangeReason}
            onChange={(e) => {
              setStatusChangeReason(e.target.value);
              setStatusChangeReasonError(null);
            }}
            placeholder="Enter reason..."
            className={`tw-px-[14px] tw-py-[5px] tw-border tw-border-solid tw-border-gray-300 tw-rounded-md tw-h-11 placeholder:tw-font-normal ${
              statusChangeReasonError ? "tw-border-red-500" : ""
            }`}
          />
          <div className="tw-flex tw-gap-2 tw-justify-end">
            <Button
              label="Cancel"
              className="tw-px-4 tw-py-2 tw-rounded-lg focus:tw-shadow-none tw-bg-gray-300 hover:tw-bg-gray-400 tw-text-gray-800 tw-font-medium"
              onClick={() => {
                setIsStatusDialogVisible(false);
                setStatusChangeReason("");
                setPendingStatusChange(null);
                setStatusChangeReasonError(null);
              }}
            />
            <Button
              label="Confirm"
              className="tw-px-4 tw-py-2 tw-rounded-lg focus:tw-shadow-none bg-primary border-primary hover:tw-bg-[#02a2db] tw-text-white tw-font-medium"
              onClick={confirmStatusChange}
              disabled={isAddButtonDisabled}
            />
          </div>
        </div>
      </Dialog>

      <Dialog
        className="comments-dialog tw-w-[444px]"
        style={{ maxWidth: "620px" }}
        header={() => {
          return (
            <div className="tw-flex tw-flex-col tw-justify-start tw-items-start tw-w-full">
              <span>Status Change History</span>
              <span>
                ({selectedRowData?.projectKey} - {selectedRowData?.name})
              </span>
            </div>
          );
        }}
        visible={viewHistoryPopup}
        draggable={false}
        onHide={() => {
          if (!viewHistoryPopup) return;
          setViewHistoryPopup(false);
        }}
      >
        <>
          {projectStatusChangeActivity &&
          projectStatusChangeActivity.length !== 0 ? (
            <Timeline
              className="tw-p-4"
              align="left"
              marker={customizedMarker}
              content={customizedContent}
              value={events}
            />
          ) : (
            <div className="tw-p-4 tw-border-b tw-text-center tw-border-b-solid tw-border-b-[#DBDBDB]">
              <p className="tw-m-0 tw-text-sm tw-font-medium tw-text-[#64748B] tw-mb-2">
                No History Found
              </p>
            </div>
          )}
        </>
      </Dialog>
    </>
  );
};

export default ProjectManagement;
